import React from 'react'
import TermsContainer from '../containers/Legal/Terms.container'

const Terms = () => <TermsContainer />

export default Terms
